module.exports = __webpack_public_path__ + "core-img/fancybox_sprite.783d4031fe50c3d83c960911e1fbc705.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/gfx/fancybox_sprite.png
// module id = 90
// module chunks = 0